import { render, staticRenderFns } from "./SingleSelectionAnswers.vue?vue&type=template&id=5d8ac1f8&"
import script from "./SingleSelectionAnswers.vue?vue&type=script&lang=js&"
export * from "./SingleSelectionAnswers.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelectionAnswers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports